import React from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  padding: 20px;
  text-align: center;
  background-color: #f5f5f5;
`;

const Title = styled.h1`
  color: #333;
  font-size: 2.5rem;
  margin-bottom: 16px;
`;

const Text = styled.p`
  color: #666;
  font-size: 1.2rem;
  margin-bottom: 32px;
`;

const Button = styled.button`
  background-color: #005CA9;
  color: white;
  border: none;
  padding: 12px 32px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 1rem;
  transition: background-color 0.3s;
  
  &:hover {
    background-color: #004080;
  }
`;

const NotFound = () => {
  const navigate = useNavigate();
  
  return (
    <Container>
      <Title>Página não encontrada</Title>
      <Text>A página que você está procurando não existe.</Text>
      <Button onClick={() => navigate('/')}>
        Voltar ao Portal da Privacidade
      </Button>
    </Container>
  );
};

export default NotFound;